import React from 'react';
import { motion } from 'framer-motion';
import { BadgePercentIcon, BookOpenCheckIcon, Clock3Icon, SparklesIcon, TrendingUpIcon, UserRoundCheckIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
const productImage = 'https://cdn.magicpatterns.com/uploads/5TWZFS4F6oyr6iQZA4tkNM/seguridad_e_higiene_(4).png';
const benefits = [[Clock3Icon, 'SAVE TIME'], [UserRoundCheckIcon, 'TEACH WITH CONFIDENCE'], [BookOpenCheckIcon, 'READY-TO-TEACH CLASSES'], [TrendingUpIcon, 'GROW YOUR SUCCESS']];
export function Hero() {
  return <section className="relative overflow-hidden bg-navy px-4 pb-16 pt-10 text-white sm:pb-20 sm:pt-14" data-id="element-123">
      <div className="absolute -right-32 top-8 size-[32rem] rounded-full bg-violet/20 blur-[120px]" aria-hidden="true" data-id="element-124" />
      <div className="relative mx-auto grid max-w-6xl items-center gap-8 lg:grid-cols-[1.1fr_.9fr] lg:gap-12" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        y: 22
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center lg:text-left" data-id="element-126">
          <p className="headline-kicker inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-3 py-1.5 text-[10px] font-bold text-violet-light" data-id="element-127">
            <SparklesIcon size={13} data-id="element-128" /> THE COMPLETE INSTRUCTOR SYSTEM
          </p>
          <h1 className="mt-5 font-display text-4xl font-black uppercase leading-[.98] tracking-tight sm:text-5xl md:text-6xl" data-id="element-129">
            Stop wasting hours planning your{' '}
            <span className="text-violet-light" data-id="element-130">dance fitness classes.</span>
          </h1>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-slate-200 lg:mx-0 sm:text-lg" data-id="element-131">
            Get ready-to-teach classes, choreography ideas, themed sessions,
            annual planning, and a complete system to save time and teach with
            confidence.
          </p>
          <div className="mt-7" data-id="element-132">
            <CheckoutButton data-id="element-133">
              GET DANCE FITNESS INSTRUCTOR PRO NOW
            </CheckoutButton>
          </div>
          <p className="mt-3 text-xs font-medium text-slate-300" data-id="element-134">
            Instant digital access • Secure checkout • 7-day guarantee
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mx-auto w-full max-w-md" data-id="element-135">
          <span className="absolute right-0 top-4 z-10 inline-flex items-center gap-1 rounded-full bg-emerald px-4 py-2 text-sm font-black text-white shadow-lg" data-id="element-136">
            <BadgePercentIcon size={18} data-id="element-137" /> 50% OFF
          </span>
          <div className="absolute inset-8 rounded-full bg-violet/25 blur-[70px]" aria-hidden="true" data-id="element-138" />
          <img src={productImage} alt="Dance Fitness Instructor Pro seven-volume ready-to-teach system" className="relative mx-auto w-full object-contain drop-shadow-[0_26px_32px_rgba(0,0,0,.45)]" data-id="element-139" />
        </motion.div>
      </div>
      <motion.div initial={{
      opacity: 0,
      y: 14
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.45,
      delay: 0.3
    }} className="relative mx-auto mt-8 grid max-w-6xl grid-cols-2 gap-3 border-t border-white/15 pt-7 sm:grid-cols-4" data-id="element-140">
        {benefits.map(([Icon, label]) => {
        const BenefitIcon = Icon as typeof Clock3Icon;
        return <div key={label} className="flex items-center gap-2 text-[10px] font-bold tracking-wide text-slate-100 sm:text-xs" data-id="element-141">
              <BenefitIcon size={19} className="shrink-0 text-violet-light" data-id="element-142" />
              {label}
            </div>;
      })}
      </motion.div>
    </section>;
}